import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { OnlineStatusContext } from "../../context/OnlineStatusContext";
import { formatLastActive } from "../../utils/helpers";
import { isMemberOnline } from "../../utils/onlineStatus";

const MemberOnlineStatus = ({ member }) => {
    const onlineUsers = useContext(OnlineStatusContext) || {};
    const currentUserId = useSelector((state) => state.user?.user?._id);

    if (!member) return null;

    const isOnline = isMemberOnline(member, onlineUsers, currentUserId);

    return (
        <div
            data-tooltip-content={isOnline ? "Online" : formatLastActive(member.lastActive)}
            data-tooltip-position="bottom"
            className={`online-indicator ${isOnline ? "online" : "offline"}`}
        ></div>
    );
};

export default MemberOnlineStatus;
